export const SessionDataMap = {
  'cacheData.data.AriesReservation.isMax': 'isMaxProperty',
};
